module.exports = __webpack_public_path__ + "media/images/illustrations/tutoring-6bc0d353fc2544b196dde7e67d6d35c3.svg";